
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    BULK_TAGS_GET_DEVICE_REQUEST,
    BULK_TAGS_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { bulkTagsGetDeviceResult, bulkTagsResult } from 'Redux/actions';


function* getEntity({ payload }) {
    try {
        const { entityName, openSearch } = payload;
        let query = ``
        let fields = []
        if (entityName === 'Unit') {
            query = `
                    query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                        result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                label
                                esn
                                imei
                            }
                            total
                        }
                    }
                    `;
                    fields = ["esn", "imei"]
        } else if (entityName === 'Company') {
            query = `
                    query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
                        result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                name
                            }
                            total
                        }
                    }
                `;
                fields = ["name"]
        }
        let data = yield call(
            clientQuery,
            query,
            {
                conditions: {
                    fields: fields,
                    terms: [openSearch],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(bulkTagsGetDeviceResult(data?.result))
        } else {
            yield put(bulkTagsGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(bulkTagsGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkTags/redux/saga",
            "getEntity",
        )
    }
}

function* assignBulkTags({ payload }) {
    try {

        let QUERY = `
            mutation assignBulkTags ($entityName: String!, $entityIds: [Int]!, $tagIds: [Int]!, $action: String) {
                result: assignBulkTags (entityName: $entityName, entityIds: $entityIds, tagIds: $tagIds, action: $action)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(bulkTagsResult({ assignBulkTags: true }))
        } else {
            yield put(bulkTagsResult({ assignBulkTags: false }))
        }

    } catch (exc) {
        yield put(bulkTagsResult({ assignBulkTags: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkTags/redux/saga",
            "assignBulkTags",
        )
    }
}

function* watchMethods() {
    yield takeEvery(BULK_TAGS_GET_DEVICE_REQUEST, getEntity);
    yield takeEvery(BULK_TAGS_REQUEST, assignBulkTags);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}